export default __webpack_public_path__ + "static/media/GMP.f4b230fe.jpg";